import { render, staticRenderFns } from "./JSONTemplateDataEditFieldList.vue?vue&type=template&id=2e55853e&scoped=true"
import script from "./JSONTemplateDataEditFieldList.vue?vue&type=script&lang=js"
export * from "./JSONTemplateDataEditFieldList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55853e",
  null
  
)

export default component.exports